<efx-modal [title]="title" [(show)]="showModal" [showFooter]="false" [size]="modalSize.extraLarge"
           (onCancel)="closeModal()" (onHide)="closeModal()" tabsHeight="400px">
  <form [formGroup]="form">
    <efx-tabs [showResponsiveDropdown]="false" [selectedIndex]="selectedTabIndex">

      <efx-tab header="General">

        <div class="row mb-3 max-h-450px overflow-y-auto">

          <div class="col-lg-12 mt-3">
            <label class="efx-label help-label">Tipo de Fuente
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('searchSourceType') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <select class="efx-select w-100" formControlName="searchSourceType">
              <option value="JOURNALING">Journaling</option>
              <option value="PURPOSING">Propósito</option>
            </select>
          </div>

          <div class="col-lg-6">
            <label class="efx-label help-label">Dominio
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('domain') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="text" placeholder="Seleccione un Dominio" matInput
                   formControlName="domain" [matAutocomplete]="autoDomain">
            <mat-autocomplete #autoDomain="matAutocomplete">
              <mat-option *ngFor="let option of filteredDomains | async" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="col-lg-6" *ngIf="form.get('searchSourceType')?.value !== 'PURPOSING'">
            <label class="efx-label help-label">SubDominio
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('subDomain') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="text" placeholder="Seleccione un SubDominio" matInput
                   formControlName="subDomain" [matAutocomplete]="autoSubDomain">
            <mat-autocomplete #autoSubDomain="matAutocomplete">
              <mat-option *ngFor="let option of filteredSubDomains | async" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="col-lg-6 mt-3" *ngIf="form.get('searchSourceType')?.value === 'PURPOSING'">
            <label class="efx-label help-label">Perfil Purposing (schema/filter)
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('purposingProfile') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="text" formControlName="purposingProfile" placeholder="Ej: PURP_DO_CREDIT_LINES" />
          </div>
        </div>

        <div class="row mb-3">


          <!-- <div class="col-lg-3">
              <label class="efx-label">
                  Tipo de Configuración
              </label>
              <select class="efx-select w-100" formControlName="configName">
                  <option value="">Seleccione una opción</option>
                  <option *ngFor="let configName of configNames" [value]="configName">{{ configName }}
                  </option>
              </select>
          </div> -->

          <div class="col-lg-3">
            <label class="efx-label help-label">
              Orden
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('order') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="number" formControlName="order" />
          </div>
          <div class="col-lg-3">
            <label class="efx-label help-label">
              Nombre Visible
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('labelDropDown') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="text" formControlName="labelDropDown" />
          </div>
          <div class="col-lg-3">
            <label class="efx-label help-label">
              Tipo De Entidad
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('profile') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <select class="efx-select w-100" formControlName="profile">
              <option value="CONSUMER">Consumer</option>
              <option value="COMMERCIAL">Commercial</option>
              <option value="null">Other</option>
            </select>
          </div>
          <div class="col-lg-3">
            <label class="efx-label help-label">
              Profile
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('profileBusqueda') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="text" formControlName="profileBusqueda" />
          </div>

          <div class="col-lg-3">
            <label class="efx-label help-label">
              Tipo Identifier
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifyType') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <input class="efx-input" type="text" formControlName="identifyType" />
          </div>

          <div class="col-lg-3">
            <label class="efx-label help-label">
              Tipo De Keying
              <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('keyingType') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
            <select class="efx-select w-100" formControlName="keyingType">
              <option value="Vacio">Vacio</option>
              <option value="COMPOSITE">Compuesto</option>
              <option value="null">Nulo</option>
            </select>

          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-3">
            <input class="efx-checkbox" type="checkbox" id="chk_entityKeyVisible" formControlName="entityKeyVisible" />
            <label for="chk_entityKeyVisible" class="help-label">Permitir visualización de EntityKey
              <span class="help-icon inline-help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('entityKeyVisible') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
          </div>
          <div class="col-lg-3">
            <input class="efx-checkbox" type="checkbox" id="chk_isHash" formControlName="isHash" />
            <label for="chk_isHash" class="help-label"> Búsqueda Hash
              <span class="help-icon inline-help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('isHash') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
          </div>

          <div class="col-lg-3">
            <input class="efx-checkbox" type="checkbox" id="chk_addEntidad" formControlName="addEntidad" />
            <label for="chk_addEntidad" class="help-label">
              Agregar Nueva Entidad
              <span class="help-icon inline-help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('addEntidad') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
          </div>

          <div class="col-lg-3">
            <input class="efx-checkbox" type="checkbox" id="chk_isDissociate"
                   formControlName="isDissociate" />
            <label for="chk_isDissociate" class="help-label">
              Permitir Disociar
              <span class="help-icon inline-help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('isDissociate') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
            </label>
          </div>
        </div>
        <efx-accordion id="accordion1" [multi]="false" [hideToggle]="false">
          <efx-accordion-item id="panel1" [hideToggle]="false" [isDisabled]="false"
                              [isExpanded]="isExpandedAdvancedSettings">
            <div class="title" [innerHTML]="'Configuración Avanzada'"></div>
            <div class="content">
              <div class="help-note mb-3">
                <strong>Ayuda:</strong> {{ getHelpText('advancedSection') }}
              </div>
              <div class="row mb-3" *ngIf="form.get('searchSourceType')?.value === 'PURPOSING'">
                <div class="col-lg-12">
                  <label class="efx-label help-label">Objeto filtro purposing (JSON)
                    <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('purposingFilterPayload') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                  </label>
                  <textarea
                    class="efx-input json-editor-input"
                    rows="6"
                    formControlName="purposingFilterPayload"
                    (blur)="formatPurposingPayloadControl()"
                    spellcheck="false"></textarea>
                </div>
              </div>

              <div class="d-flex justify-content-end py-2">
                <button class="efx-button-primary" (click)="addConfigAvanced()">
                  Agregar
                </button>
              </div>

              <div formArrayName="configAvanced">
                <div *ngFor="let control of getControls('configAvanced'); let i = index">

                  <div [formGroupName]="i" class="mb-3 border-bottom pb-2">
                    <div class="row">
                      <div class="col-lg-4">
                        <label class="efx-label help-label">Nombre de atributo
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('advancedName') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <input class="efx-input" type="text" formControlName="name" />
                      </div>
                      <div class="col-lg-4">
                        <label class="efx-label help-label">Título
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('advancedLabel') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <input class="efx-input" type="text" formControlName="label" />
                      </div>
                      <div class="col-lg-4">
                        <label class="efx-label help-label">Tipo
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('advancedType') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <select class="efx-select w-100" formControlName="type">
                          <option value="text">Texto</option>
                          <option value="number">Numérico</option>
                        </select>
                      </div>

                      <div class="col-lg-4">
                        <label class="efx-label help-label">Orden
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('advancedOrder') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <input class="efx-input" type="number" formControlName="order" />
                      </div>

                      <div class="col-lg-4">
                        <label class="efx-label help-label">Es Párametro de búsqueda
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('advancedVisible') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <select class="efx-select w-100" formControlName="visible">
                          <option [ngValue]="true">Si</option>
                          <option [ngValue]="false">No</option>
                        </select>
                      </div>

                      <div class="col-lg-4 d-flex gap-3 align-items-center">
                        <div>

                          <label class="efx-label help-label">Es requerido
                            <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('advancedRequired') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                          </label>
                          <select class="efx-select w-100" formControlName="required">
                            <option [ngValue]="true">Si</option>
                            <option [ngValue]="false">No</option>
                          </select>

                        </div>

                        <div>
                          <button class="efx-button-danger mb-3"
                                  (click)="deleteConfigAvanced(i)">
                            <i class="far fa-trash-alt"></i>
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </efx-accordion-item>

          <efx-accordion-item id="panel2" [hideToggle]="false" [isDisabled]="false"
                              [isExpanded]="isExpandedIdentifiersSettings">
            <div class="title" [innerHTML]="'Identifier'"></div>
            <div class="content">
              <div class="help-note mb-3">
                <strong>Ayuda:</strong> {{ getHelpText('identifiersSection') }}
              </div>
              <div class="d-flex justify-content-end py-2">
                <button class="efx-button-primary" (click)="addIdentifiers()">
                  Agregar
                </button>
              </div>

              <div formArrayName="identifiers">
                <div *ngFor="let control of getControls('identifiers'); let i = index">

                  <div [formGroupName]="i" class="mb-3 border-bottom pb-2">
                    <div class="row">
                      <div class="col-lg-4">
                        <label class="efx-label help-label">Nombre de atributo
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierName') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <input class="efx-input" type="text" formControlName="name" />
                      </div>
                      <div class="col-lg-4">
                        <label class="efx-label help-label">Título
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierLabel') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <input class="efx-input" type="text" formControlName="label" />
                      </div>
                      <div class="col-lg-4">
                        <label class="efx-label help-label">Tipo
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierType') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <select class="efx-select w-100" formControlName="type">
                          <option value="text">Texto</option>
                          <option value="number">Numérico</option>
                        </select>
                      </div>

                      <div class="col-lg-4">
                        <label class="efx-label help-label">Orden
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierOrder') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <input class="efx-input" type="number" formControlName="order" />
                      </div>

                      <div class="col-lg-4">
                        <label class="efx-label help-label">Es párametro de búsqueda
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierVisible') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <select class="efx-select w-100" formControlName="visible">
                          <option [ngValue]="true">Si</option>
                          <option [ngValue]="false">No</option>
                        </select>
                      </div>

                      <div class="col-lg-4">
                        <label class="efx-label help-label">Tipo de valor
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierTypeValue') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>
                        <select class="efx-select w-100" formControlName="typeValue">
                          <option value="input">Valor del Input</option>
                          <option value="countryCode">Código de País</option>
                          <option value="countryName">Nombre de País</option>
                          <option value="">Valor personalizado</option>
                        </select>
                      </div>

                      <div class="col-lg-4"
                           *ngIf="['', 'countryCode', 'countryName'].includes(control.get('typeValue')?.value)">
                        <label class="efx-label help-label">
                          {{ control.get('typeValue')?.value === '' ? 'Valor Personalizado' :
                          'Valor Automático' }}
                          <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierValue') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                        </label>

                        <input class="efx-input" type="text" formControlName="value"
                               placeholder="Ingrese valor"
                               [readonly]="control.get('typeValue')?.value !== ''"
                               [ngClass]="{'bg-light': control.get('typeValue')?.value !== ''}" />
                      </div>



                      <div class="col-lg-4 d-flex gap-3 align-items-center">
                        <div>

                          <label class="efx-label help-label">Es requerido
                            <span class="help-icon" efxTooltip efxTooltipTitle="{{ getHelpText('identifierRequired') }}" efxTooltipPlacement="right" efxTooltipMode="dark">help</span>
                          </label>
                          <select class="efx-select w-100" formControlName="required">
                            <option [ngValue]="true">Si</option>
                            <option [ngValue]="false">No</option>
                          </select>

                        </div>

                        <div>
                          <button class="efx-button-danger mb-3"
                                  (click)="deleteIdentifiers(i)">
                            <i class="far fa-trash-alt"></i>
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </efx-accordion-item>
        </efx-accordion>

      </efx-tab>
      <efx-tab header="Tabla" [isVisible]="isVisibleTabEnabled" [ngClass]="{'d-none':tabletModal.length === 0}">
        <div class="min-h-450px" *ngIf="tabletModal.length > 0">
          <app-tabla-dinamica-buscador [inFlowTable]="flowTableModal" [inStructField]="inStructModal"
                                       [inDataValues]="tabletModal" (setTabletAbm)="saveConfigTable($event)">
          </app-tabla-dinamica-buscador>

        </div>
      </efx-tab>

    </efx-tabs>

    <div class="d-flex justify-content-end py-3">
      <button class="efx-button-secondary me-2" (click)="closeModal()">Cancelar</button>
      <button class="efx-button-primary" [disabled]="form.invalid" (click)="onSubmit()">Guardar</button>
    </div>
  </form>

</efx-modal>
